import config from '../config/config';
import { DependencyList, EffectCallback, useEffect } from 'react';

/**
 * Wraps the passed in effect within setTimeout function.
 * @param effect - Same function that you would write inside `useEffect` hook
 * @param deps - Same dependency array that you would write inside `useEffect` hook
 * @param timeoutDuration - Wait time before effect is executed, default value is located within config
 * @returns void
 */
export const useDebounceEffect = (effect: EffectCallback, deps?: DependencyList, timeoutDuration?: number): void =>
	useEffect(() => {
		const timeout = setTimeout(() => {
			effect();
		}, timeoutDuration ?? config.defaultTimeout);

		return () => clearTimeout(timeout);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, deps);
